<template>
  <div class="custom-container" >
    <!-- v-loading.fullscreen.lock="ppn.isLoading" -->
    <el-container class="category-title my-2">PPN</el-container>

    <el-row :gutter="15" class="mt-4">
      <el-col>
        <el-card class="mb-2" shadow="never">
          <el-row :gutter="20" class="mt-4">
            <el-col>
              <el-form :model="formPPN" ref="formPPN" class="demo-ruleForm">
                <el-form-item label="Persentase PPN" prop="nominal" :rules="rules" >
                  <!--style="float: right"-->
                  <el-col :span="5" style="min-width: 70px">
                    <el-input size="small" v-model="formPPN.nominal" step="0.1" min="0.0" autocomplete="off" type="number"></el-input> 
                    <!-- v-model.number="ppn.data.nominal" -->
                  </el-col>
                  <el-col :span="1">
                     %
                  </el-col>
                </el-form-item>
                
                <el-form-item>
                  <el-row type="flex" justify="end">
                    <el-col >
                      <el-button size="small" type="primary" @click="save">Submit</el-button>
                    </el-col>
                    <el-col >
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-form> 
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
/* eslint-disable */
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  components: {},
  data: () => ({
    // formPPN: {
    //   nominal: 0
    // },
    rules: [
      {
        required: true,
        message: 'Persentase is required',
      },
      // {
      //   message: 'Persentase must be a float',
      //   trigger: "blur",
      // }
    ]
  }),
  computed: {
    formPPN: {
      get () {
        return this.$store.state.ppn.ppn.data
      },
      set (value) {
        this.setPPN(value)
      }
    }
  },
  methods: {
    ...mapActions({
      getPPN: "ppn/GetPPN",
      updatePPN: "ppn/UpdatePPN",
    }),
    ...mapMutations({
      setPPN: "ppn/UPDATE_PPN_NOMINAL"
    }),
    save() {
      this.$refs.formPPN.validate((valid) => {
        if (valid) {
          const payload = {
            set: {
              nominal: this.formPPN.nominal
            },
            where: {
              taxId: this.formPPN.taxId
            }
          };
          this.updatePPN(payload);
        }
      })
    },
  },
  created() {
    this.getPPN();
  }
};
</script>

<style>
.demo-input-label {
    display: inline-block;
    width: 90px;
  }
</style>
